define((require) => {
    "use strict";

    const Class   = require("shared/util/Class");
    const Promise = require("shared/util/Promise");
    const $       = require("jquery");

    /**
     * Enables execution of multiple actions in sequence. Actions are executed in the order
     * they are added.
     *
     * @class ActionSequence
     * @see  util/Action
     *
     * @author Kim
     */
    return Class.extend({

        _actions: null,

        /**
         * Constructor.
         *
         * @param  {Action[]} actions Optional array of <tt>Action</tt>'s.
         */
        constructor(actions) {
            this._actions = actions || [];
        },

        /**
         * Adds a new action.
         *
         * @param {Action} action Action that will be executed.
         */
        add(action) {
            this._actions.push(action);

            return this;
        },

        /**
         * Starts execution.
         *
         * First added action will be executed immediately, once the action's deferred object has been
         * resolved (successful execution), the next action is executed and so forth.
         *
         * @return {Promise} Promise that resolves, with an array of all resolved values, once all actions
         *                           have been successfully executed/resolved.
         */
        execute() {
            const actions = this._actions;

            return Promise.deferred((deferred) => {
                const firstAction = actions.shift();
                const results = [];
                const add = (deferred) => {
                    deferred.then((value) => results.push(value));

                    return deferred;
                };

                let when = add($.when(firstAction.execute()));

                while (actions.length) {
                    when = add(when.then(actions.shift().execute));
                }

                when.done(deferred.resolve.bind(deferred, results));
            }).promise();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/util/ActionSequence.js